module.exports = __webpack_public_path__ + "img/choose.b278e767.png";